import React from 'react';
import SEO from '../components/SEO';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#0A192F] pt-24 pb-20">
      <SEO
        title="Terms of Service"
        description="Terms governing the use of Infotron Solutions' website, services, and engagements."
        path="/terms"
      />
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <h1 className="text-4xl lg:text-5xl font-bold text-white mb-4">Terms of Service</h1>
        <p className="text-gray-400 mb-12">Last updated: March 5, 2026</p>

        <div className="space-y-10 text-gray-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
            <p className="leading-relaxed">
              By accessing and using the Infotron Solutions website and services, you accept and agree to be 
              bound by these Terms of Service. If you do not agree to these terms, please do not use our 
              website or services. These terms apply to all visitors, users, clients, and others who access 
              or use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. Description of Services</h2>
            <p className="leading-relaxed">
              Infotron Solutions provides IT consulting, managed services, staff augmentation, and business 
              consulting services to enterprise and growth-stage organizations. Our website provides information 
              about our services, career opportunities, and resources for potential clients and candidates.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Use of Website</h2>
            <p className="leading-relaxed mb-4">You agree to use our website only for lawful purposes and in accordance with these Terms. You agree not to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Use the website in any way that violates applicable laws or regulations</li>
              <li>Attempt to gain unauthorized access to any part of the website or its systems</li>
              <li>Interfere with or disrupt the website or servers connected to it</li>
              <li>Transmit any viruses, malware, or other malicious code</li>
              <li>Collect or harvest any information from the website without authorization</li>
              <li>Impersonate any person or entity or misrepresent your affiliation</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Intellectual Property</h2>
            <p className="leading-relaxed">
              All content on this website, including but not limited to text, graphics, logos, images, and 
              software, is the property of Infotron Solutions or its content suppliers and is protected by 
              intellectual property laws. You may not reproduce, distribute, modify, create derivative works, 
              publicly display, or exploit any content without our prior written consent.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Client Engagements</h2>
            <p className="leading-relaxed">
              All client engagements, including managed services, staff augmentation, and consulting projects, 
              are governed by separate service agreements (Master Service Agreements, Statements of Work, etc.) 
              negotiated and executed between Infotron Solutions and the client. These Terms of Service do not 
              constitute a service agreement and do not create any obligation for Infotron Solutions to provide 
              services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Job Applications</h2>
            <p className="leading-relaxed">
              Job applications submitted through our careers portal are processed by CEIPAL, our applicant 
              tracking system provider. By submitting a job application, you agree to CEIPAL's terms of service 
              and privacy policy. Submission of an application does not guarantee employment or create any 
              employment relationship with Infotron Solutions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Disclaimer of Warranties</h2>
            <p className="leading-relaxed">
              THE WEBSITE AND ALL CONTENT ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, 
              EITHER EXPRESS OR IMPLIED. INFOTRON SOLUTIONS DISCLAIMS ALL WARRANTIES, INCLUDING BUT NOT LIMITED TO 
              IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO 
              NOT WARRANT THAT THE WEBSITE WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Limitation of Liability</h2>
            <p className="leading-relaxed">
              TO THE FULLEST EXTENT PERMITTED BY LAW, INFOTRON SOLUTIONS SHALL NOT BE LIABLE FOR ANY INDIRECT, 
              INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER 
              INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, 
              RESULTING FROM YOUR ACCESS TO OR USE OF THE WEBSITE OR SERVICES.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Indemnification</h2>
            <p className="leading-relaxed">
              You agree to indemnify, defend, and hold harmless Infotron Solutions, its affiliates, officers, 
              directors, employees, and agents from and against any claims, liabilities, damages, losses, and 
              expenses, including reasonable attorneys' fees, arising out of or in any way connected with your 
              access to or use of the website or your violation of these Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">10. Third-Party Links</h2>
            <p className="leading-relaxed">
              Our website may contain links to third-party websites or services that are not owned or controlled 
              by Infotron Solutions. We have no control over and assume no responsibility for the content, privacy 
              policies, or practices of any third-party websites or services. You acknowledge and agree that 
              Infotron Solutions shall not be responsible or liable for any damage or loss caused by or in 
              connection with the use of any such third-party websites or services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">11. Confidentiality</h2>
            <p className="leading-relaxed">
              Any confidential information shared with Infotron Solutions through the website, including business 
              requirements, technical specifications, or other proprietary information, will be treated as 
              confidential and will not be disclosed to third parties without your consent, except as required 
              by law or as necessary to provide our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">12. Governing Law</h2>
            <p className="leading-relaxed">
              These Terms shall be governed by and construed in accordance with the laws of the State of Nevada, 
              United States, without regard to its conflict of law provisions. Any disputes arising under these 
              Terms shall be subject to the exclusive jurisdiction of the courts located in Clark County, Nevada.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">13. Changes to Terms</h2>
            <p className="leading-relaxed">
              We reserve the right to modify or replace these Terms at any time at our sole discretion. We will 
              provide notice of any material changes by posting the new Terms on this page and updating the 
              "Last updated" date. Your continued use of the website after any such changes constitutes your 
              acceptance of the new Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">14. Severability</h2>
            <p className="leading-relaxed">
              If any provision of these Terms is held to be invalid or unenforceable, such provision shall be 
              struck and the remaining provisions shall be enforced to the fullest extent under law.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">15. Contact Information</h2>
            <p className="leading-relaxed mb-4">
              For any questions about these Terms of Service, please contact us:
            </p>
            <div className="bg-slate-800/50 border border-blue-600/20 rounded-xl p-6">
              <p className="mb-2"><strong className="text-white">Infotron Solutions</strong></p>
              <p className="mb-2">Email: <a href="mailto:contact@infotronsolutions.com" className="text-blue-500 hover:text-blue-400">contact@infotronsolutions.com</a></p>
              <p className="mb-2">Phone: +1 (775) 305 9399</p>
              <p>Address: 3225 McLeod Dr. Ste 100, Las Vegas, NV 89121</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
